var render, staticRenderFns
import script from "./Drawer.vue?vue&type=script&lang=tsx"
export * from "./Drawer.vue?vue&type=script&lang=tsx"
import style0 from "./Drawer.vue?vue&type=style&index=0&id=195c0e5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195c0e5d",
  null
  
)

export default component.exports